import { createAction } from 'redux-actions';

import types from './types';

const initialize = createAction(types.INITIALIZE);
const loadSamples = createAction(types.LOAD_SAMPLES);
const setProducts = createAction(types.SET_PRODUCTS);
const setRemoveSamplesCheckbox = createAction(types.SET_REMOVE_SAMPLES_CHECKBOX);
const setCategoryCode = createAction(types.SET_CATEGORY_CODE);
const setLoading = createAction(types.SET_LOADING);
const setClickedSample = createAction(types.SET_CLICKED_SAMPLE);
const setHideFreeSamples = createAction(types.SET_HIDE_FREE_SAMPLES);
const setAllowedSamplesChanged = createAction(types.SET_ALLOWED_SAMPLES_CHANGED);

export default {
    initialize,
    loadSamples,
    setProducts,
    setRemoveSamplesCheckbox,
    setCategoryCode,
    setLoading,
    setHideFreeSamples,
    setAllowedSamplesChanged,
    setClickedSample,
};
